import React, { MouseEventHandler } from "react";

import "./style.css";

export interface ButtonProps {
  loader?: boolean;
  submit: MouseEventHandler<HTMLButtonElement> | undefined;
  loadingText?: string;
  label: string;
  customClass?: string;
  disabled?: boolean;
}

const Button = (props: ButtonProps) => (
  <button
    aria-label={props.label}
    className={`submit-btn ${props.customClass}`}
    disabled={props.loader || props.disabled}
    onClick={props.submit}
    data-track={`${props.label}-button`}
  >
    {props.loader ? (
      <div>
        <div
          className="inline-block h-4 w-4 mr-2 mt-1 animate-spin rounded-full border-4 border-solid border-current border-white border-b-grey-scale-blue-grey-100 align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
          data-track="loading-spinner"
        >
          {" "}
        </div>{" "}
        {props.loadingText}
      </div>
    ) : (
      <span data-track="button-label">{props.label}</span>
    )}
  </button>
);

export default Button;
